import { Injectable, inject } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { ContextMembership, NetworkConstants, Trophy } from 'diwimamodelweb/lib';
import { diffObject, updatesToFirestoreUpdates } from 'diwimamodelweb/lib/utils/obejct-diff';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { skipWhile, take, takeUntil } from 'rxjs/operators';
import { SettingsService } from './settings.service';
import { TransactionLogService } from './transaction-log.service';
import { UserService } from './user.service';
import { deepCopy, removeUndefined } from 'diwimamodelweb/lib';
import { Firestore, collection, collectionData, deleteDoc, doc, query, updateDoc, where } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class TrophyService {
  ngUnsubscribe: Subject<void> = new Subject<void>();
  private Ifirestore = inject(Firestore);

  subscriptions: Map<string, Subscription> = new Map([])
  trophySubject$ = new BehaviorSubject<Trophy[]>(undefined)
  subbedContext: string|undefined = undefined
  constructor(
    private settingsService: SettingsService,
    private firestore: AngularFirestore,
    private userService: UserService,
    private transactionLogService: TransactionLogService
  ) {
    // this.settingsService.selectedUserContext$.pipe(
    // ).subscribe((context) => {
    //   if (!context) {
    //     this.subbedContext = undefined
    //     return 
    //   }
    //   if(this.subbedContext?.identifier == context.identifier) return 
    //   this.trophySubject$.next(undefined)
    //   if (this.subscriptions.get('1')) this.subscriptions.get('1').unsubscribe()
    //   const sub = this.observeTrophies(context)
    //   this.subscriptions.set('1', sub)
    //   this.subbedContext = context
    // })
  }

  observeData(contextId) {
    if (this.subbedContext == contextId) return 
    if (this.subscriptions.get('1')) this.subscriptions.get('1').unsubscribe()
    if (!!this.trophySubject$.value) this.trophySubject$.next(undefined)
    const sub = this.observeTrophies(contextId)
    this.subscriptions.set('1', sub)
    this.subbedContext = contextId
  }

  resetData() {
    this.trophySubject$.next(null)
  }

  async removeSubs(): Promise<void> {
    this.ngUnsubscribe.next()
    this.subbedContext = undefined
    this.subscriptions.forEach((value) => {
      value.unsubscribe()
    })
    this.resetData()
    return Promise.resolve()
  }


  observeTrophies(contextId: string) {
    // return this.firestore.collection(NetworkConstants.COLLECTION_TROPHY, ref => ref.where('contextId', "==", contextId).valueChanges()
    const path = `${NetworkConstants.COLLECTION_TROPHY}`
    const collRef = collection(this.Ifirestore, path);
    const q = query(collRef, where('contextId', '==', contextId));
    return collectionData(q)
      .pipe(
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(async (values: any[]) => {
        // values to person 
        var list: Trophy[] = []
        const context = await this.settingsService.selectedUserContext$.pipe(
          skipWhile(el => !el),
          take(1)
        ).toPromise()
        values.forEach((element: any) => {
          const trophy = new Trophy(context)
          trophy.setFromAny(element)
          list.push(trophy)
        })
        this.trophySubject$.next(list)
      })
  }

  updateTrophy(oldTrophy: Trophy, newTrophy: Trophy): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const updates = diffObject(oldTrophy, newTrophy, {})
      const map = updatesToFirestoreUpdates(updates)
      try {
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const list = await this.transactionLogService.determineDiff(user, updates, newTrophy.identifier, NetworkConstants.COLLECTION_TROPHY)
        map['updateTimestamp'] = new Date()
        // await this.firestore.collection(NetworkConstants.COLLECTION_TROPHY).doc(newTrophy.identifier).update(map)
        const docRef = doc(this.Ifirestore, NetworkConstants.COLLECTION_TROPHY, newTrophy.identifier)
        await updateDoc( docRef, map)
        // if successfull save transactionlog..
        await this.transactionLogService.saveTransactionLog(list)
        resolve()      
      } catch (error) {
        reject(error)
      }
    })
  }

  deleteTrophy(trophy: Trophy): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        const personToDelete = deepCopy(trophy, trophy.replacerFn)
        const dataToDelete = removeUndefined(personToDelete)
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const transactionLogItem = this.transactionLogService.deleteDocumentLog(
          user,
          trophy.identifier,
          NetworkConstants.COLLECTION_TROPHY,
          dataToDelete
        )
        const promiseArray = []
        promiseArray.push(
          this.transactionLogService.saveTransactionLog([transactionLogItem])
        )
        // const delOperation = this.firestore.collection(NetworkConstants.COLLECTION_TROPHY).doc(trophy.identifier).delete()

        const docRef = doc(this.Ifirestore, NetworkConstants.COLLECTION_TROPHY, trophy.identifier)
        const delOperation = await deleteDoc( docRef)
        
        promiseArray.push(delOperation)
        resolve()
      } catch (error) {
        reject(error)        
      } 
    })
  }
}
